jQuery(function ( $ ) {

	var cat_program, specialty, program;

	function init_reg_form() {
		if( $('.js-form-registration').size() > 0 ) {
			var data = new FormData(document.getElementsByClassName('js-form-registration')[0]);

			cat_program = data.get('cat');
			specialty   = data.get('spec');
			program     = data.get('program');
		}
	}

	init_reg_form();

	$('.js-slider').slider({
		classItm : '.js-slider__itm',
		countView: 2,
		moveSize : 1,
		interval : 8000
	});

	$('.js-gall-slider').slider({
		classItm : '.js-gall-slider__itm',
		countView: 1,
		moveSize : 1,
		interval : 8000
	});

	$('.js-show-advantages').click(function () {
		$('.js-advantages').not(':first-child').slideToggle(300);
		$(this).toggleClass('active');

		return false;
	});

	/*******************************************************************/
	/********************** mobile menu ********************************/
	$(document).on('click', '.js-open-menu', function ( e ) {
		e.preventDefault();

		$('.js-sidebar').toggleClass('open');

		$(this).toggleClass('open');

		if( $(this).hasClass('open') ) {
			$('html').css('overflow', 'hidden');
		} else {
			$('html').css('overflow', 'auto');
		}
	});


	/*******************************************************************/
	/********************** page program *******************************/
	$(document).on('click', '.js-show-all-progs', function (e) {
		e.preventDefault();

		$(this).closest('.js-all-program-list').find('li:nth-child(n+5)').not('.all-program-list__show-all').slideToggle(200);
	});


	$(document).on('click', '.js-open-answer', function () {
		$('.js-answer').not( $(this).siblings('.js-answer') ).slideUp(200);

		$(this).siblings('.js-answer').slideToggle(200);
	});

	/*******************************************************************/
	/********************** Start YT video ********************************/
	$(document).on('click', '.js-start-yt-video', function () {
		var id = $(this).parent('.js-yt-video').attr('data-videoid'),
		    hg = $(this).parent('.js-yt-video').width() * 0.5625;

		$(this).parent('.js-yt-video').html('<iframe width="100%" height="' + hg + '" src="http://www.youtube.com/embed/' + id + '?autoplay=1" frameborder="0" allowfullscreen></iframe>');
	});


	/*******************************************************************/
	/*********************** Contact form ******************************/
	$(document).on('submit', '.js-cform', function ( e ) {
		var formData = $(this).serialize() + '&action=sml_theme_ajax_send_cform',
		    form     = $(this);

		e.preventDefault();

		$('.loader').fadeIn(200);
		form.find('.js-f-result').slideUp(200);

		fetch(window.theme_vars.ajax_url, {
			method : 'post',
			headers: {
				'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
			},
			body   : formData
		})
			.then(function ( response ) {
				var contentType = response.headers.get("content-type");

				if( contentType && contentType.includes("application/json") ) {
					return response.json();
				}
			})
			.then(function ( json ) {
				var data = JSON.parse(json.data);

				$('.loader').fadeOut(200);

				if( data.error ) {
					form.find('.js-f-result').html(data.error).slideDown(200);
				}

				if( data.success ) {
					form.find('.js-f-result').html(data.success).slideDown(200);

					form.trigger('reset');
				}

				return true;
			})
			.catch(alert);

		return false;
	});

	/*******************************************************************/
	/********************** Feedback form ******************************/
	$(document).on('click', '.js-open-fb', function () {
		$('.js-fb-main-form').slideToggle(300);
		$(this).closest('.js-add-fb').toggleClass('open');
	});

	$(document).on('submit', '.js-add-fb', function ( e ) {
		var formData = $(this).serialize() + '&action=sml_ajax_send_fb';

		e.preventDefault();
		$('.loader').fadeIn(200);
		$('.js-fb-result').slideUp(200);

		fetch(window.program_vars.ajax_url, {
			method : 'post',
			headers: {'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'},
			body   : formData
		})
			.then(function ( response ) {
				var contentType = response.headers.get("content-type");

				if( contentType && contentType.includes("application/json") ) {
					return response.json();
				}
			})
			.then(function ( json ) {
				$('.loader').fadeOut(200);

				var data = JSON.parse(json.data);

				if( data.error ) {
					$('.js-fb-result').html(data.error).slideDown(200);
				}

				if( data.success ) {
					$('.js-fb-result').html(data.success).slideDown(200);

					$('.js-fb-main-form').slideToggle(300);
					$('.js-add-fb').removeClass('open').trigger('reset');

					setTimeout(function () {
						$('.js-fb-result').html(data.success).slideUp(200);
					}, 8000);
				}
				return true;
			})
			.catch(alert);
	});


	/*******************************************************************/
	/******************* Processing registration form ******************/
	function empty_select( select ) {
		var first_val = select.find('option').first().clone();

		select.empty().append(first_val);
	}


	function get_form_selects( form ) {
		var data = form.serialize() + '&action=sml_ajax_get_form_info';

		$('.loader').fadeIn(200);

		fetch(window.program_vars.ajax_url, {
			method : 'post',
			headers: {'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'},
			body   : data
		})
			.then(function ( response ) {
				var contentType = response.headers.get("content-type");

				if( contentType && contentType.includes("application/json") ) {
					return response.json();
				}
			})
			.then(function ( json ) {
				$('.loader').fadeOut(200);
				var data = JSON.parse(json.data),
				    select_name, select_wrap, data_append;

				var spec_block     = form.find('.js-spec-select'),
				    programs_block = form.find('.js-program-select'),
				    date_block     = form.find('.js-program-date-select');

				// Дата начала
				if( data.date_start ) {
					select_name = date_block.find('select');
					select_wrap = date_block;
					data_append = data.date_start;
				}

				// Программы
				if( data.programs ) {
					select_name = programs_block.find('select');
					select_wrap = programs_block;
					data_append = data.programs;
				}

				// Специальности
				if( data.specialties ) {
					select_name = spec_block.find('select');
					select_wrap = spec_block;
					data_append = data.specialties;
				}

				// Добавление и отображение
				empty_select(select_name);

				data_append.forEach(function ( itm ) {
					select_name.append('<option value="' + itm.id + '">' + itm.title + '</option>');
				});

				select_wrap.slideDown(200);

				init_select_style();
			})
			.catch(alert);
	}

	function change_cat( form, selected_cat_program ) {
		var spec_block     = form.find('.js-spec-select'),
		    programs_block = form.find('.js-program-select'),
		    date_block     = form.find('.js-program-date-select');

		empty_select(spec_block.find('select'));
		empty_select(programs_block.find('select'));
		empty_select(date_block.find('select'));

		spec_block.slideUp(200);
		programs_block.slideUp(200);
		date_block.slideUp(200);

		cat_program = selected_cat_program;

		if( !cat_program ) {
			return false;
		}

		get_form_selects(form);
	}

	function change_spec( form, selected_specialty ) {
		var programs_block = form.find('.js-program-select'),
		    date_block     = form.find('.js-program-date-select');

		empty_select(programs_block.find('select'));
		empty_select(date_block.find('select'));

		programs_block.slideUp(200);
		date_block.slideUp(200);

		specialty = selected_specialty;

		if( !specialty ) {
			return false;
		}

		get_form_selects(form);
	}

	function change_prog( form, selected_program ) {
		var date_block = form.find('.js-program-date-select');

		empty_select(date_block.find('select'));

		date_block.slideUp(200);

		program = selected_program;

		if( !program ) {
			return false;
		}

		get_form_selects(form);
	}


	$(document).on('change', '.js-form-registration', function () {
		var form = $(this),
		    data = new FormData(this);

		var selected_cat_program = data.get('cat'),
		    selected_specialty   = data.get('spec'),
		    selected_program     = data.get('program');


		if( selected_cat_program !== cat_program ) {
			change_cat(form, selected_cat_program);

			return true;
		}

		if( selected_specialty !== specialty ) {
			change_spec(form, selected_specialty);

			return true;
		}

		if( selected_program !== program ) {
			change_prog(form, selected_program);

			return true;
		}

		return false;
	});

	//  Регистрация на событие
	$(document).on('submit', '.js-form-registration', function ( e ) {
		var formData = $(this).serialize() + '&action=sml_ajax_reg_event',
		    form     = $(this);

		e.preventDefault();

		$('.loader').fadeIn(200);
		form.find('.js-f-result').slideUp(200);

		fetch(window.program_vars.ajax_url, {
			method : 'post',
			headers: {
				'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
			},
			body   : formData
		})
			.then(function ( response ) {
				var contentType = response.headers.get("content-type");

				if( contentType && contentType.includes("application/json") ) {
					return response.json();
				}
			})
			.then(function ( json ) {
				var data = JSON.parse(json.data);

				$('.loader').fadeOut(200);

				if( data.error ) {
					form.find('.js-f-result').html(data.error).slideDown(200);
				}

				if( data.success ) {
					form.find('.js-f-result').html(data.success).slideDown(200);

					form.trigger('reset');
					change_cat(form, '');
					init_select_style();
					init_checkbox_style();
				}

				return true;
			})
			.catch(alert);

		return false;
	});

	/*************************************************************************/
	/************************** SELECT STYLING *******************************/
	function init_select_style() {
		$('select.js-styling-select').each(function () {
			if( !$(this).parent().is('.style-select') ) {
				$(this).wrap('<div class="style-select"></div>');
				$(this).parent('.style-select').prepend('<p class="style-select__title"></p>');
			}

			var selected = $(this).children('option:selected');

			if( selected.val() ) {
				$(this).parent().removeClass('none_selected');
			} else {
				$(this).parent().addClass('none_selected');
			}

			$(this).siblings('.style-select__title').text(selected.text());
		});
	}

	init_select_style();

	$(document).on('change', 'select.js-styling-select', function () {
		var selected = $(this).children('option:selected');

		if( selected.val() ) {
			$(this).parent().removeClass('none_selected');
		} else {
			$(this).parent().addClass('none_selected');
		}

		$(this).siblings('.style-select__title').text(selected.text());
	});

	$(document).on('focus', 'select.js-styling-select', function () {
		$(this).parent('.style-select').addClass('focus');
	});

	$(document).on('keyup', 'select.js-styling-select', function () {
		$(this).siblings('.style-select__title').text($(this).children('option:selected').text());
	});

	$(document).on('blur', 'select.js-styling-select', function () {
		$(this).parent('.style-select').removeClass('focus');
	});

	$(document).on('mouseenter', 'select.js-styling-select', function () {
		$(this).parent('.style-select').addClass('focus');
	});

	$(document).on('mouseleave', 'select.js-styling-select', function () {
		$(this).parent('.style-select').removeClass('focus');
	});


	/*************************************************************************/
	/************************ CHECKBOX STYLING *******************************/
	function init_checkbox_style() {
		$('input.js-styling-check').each(function () {
			if( !$(this).parent().is('.style-checkbox') ) {
				$(this).wrap('<span class="style-checkbox"></span>');
			}

			if( $(this).prop('checked') ) {
				$(this).parent('.style-checkbox').addClass('checked');
			} else {
				$(this).parent('.style-checkbox').removeClass('checked');
			}
		});
	}

	init_checkbox_style();

	$(document).on('change', 'input.js-styling-check', function () {
		if( $(this).prop('checked') ) {
			$(this).parent('.style-checkbox').addClass('checked');
		} else {
			$(this).parent('.style-checkbox').removeClass('checked');
		}
	});

	$(document).on('focus', 'input.js-styling-check', function () {
		$(this).parent('.style-checkbox').addClass('focus');
	});

	$(document).on('blur', 'input.js-styling-check', function () {
		$(this).parent('.style-checkbox').removeClass('focus');
	});

	$(document).on('mouseenter', 'input.js-styling-check', function () {
		$(this).parent('.style-checkbox').addClass('focus');
	});

	$(document).on('mouseleave', 'input.js-styling-check', function () {
		$(this).parent('.style-checkbox').removeClass('focus');
	});
});